var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, "-->\n", /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 34,
    width: 124,
    height: 189
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190 34H66V223H190V34Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 223C93.8443 223 66 180.635 66 128.5C66 76.3646 93.8443 34 128 34C162.156 34 190 76.3646 190 128.5C190 180.635 162.156 223 128 223ZM128 39.0718C96.5916 39.0718 71.0491 79.1989 71.0491 128.5C71.0491 177.801 96.5916 217.928 128 217.928C159.408 217.928 184.951 177.801 184.951 128.5C184.951 79.1989 159.408 39.0718 128 39.0718Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.515 70.2486C114.635 70.2486 101.269 68.6823 87.7557 64.1326C86.4192 63.6851 85.7509 62.268 86.1964 60.9254C86.6419 59.5829 88.0527 58.9116 89.3892 59.3591C128.297 72.4862 167.279 59.0608 167.725 58.9116C169.061 58.4641 170.472 59.1354 170.917 60.4779C171.363 61.8205 170.695 63.2376 169.358 63.6851C168.244 64.058 150.35 70.2486 126.515 70.2486Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7809 188.914C82.7809 188.914 82.1868 188.914 81.9641 188.765C80.6276 188.318 79.9593 186.826 80.4791 185.558L89.018 161.84V95.16L79.588 71.3674C79.0683 70.0994 79.7365 68.6077 80.9988 68.0856C82.2611 67.5635 83.7461 68.2348 84.2659 69.5027L93.8443 93.7431C93.8443 93.7431 93.9928 94.34 93.9928 94.713V162.287C93.9928 162.287 93.9928 162.884 93.8443 163.182L85.1569 187.348C84.7856 188.392 83.8204 188.989 82.7809 188.989V188.914Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.8611 111.345C69.0443 111.345 68.3018 110.972 67.782 110.227C66.9653 109.108 67.2623 107.541 68.4503 106.721L88.9437 92.4006L126.292 35.1188C127.035 33.9254 128.594 33.6271 129.782 34.3729C130.97 35.1188 131.267 36.6851 130.525 37.8785L92.879 95.608C92.879 95.608 92.5078 96.13 92.2108 96.279L71.3461 110.823C70.9006 111.122 70.3808 111.271 69.9353 111.271L69.8611 111.345Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.322 111.345C184.802 111.345 184.357 111.196 183.911 110.898L163.047 96.354C163.047 96.354 162.527 95.906 162.378 95.682L124.733 37.8785C123.99 36.6851 124.287 35.1188 125.475 34.3729C126.663 33.6271 128.223 33.9254 128.965 35.1188L166.314 92.4752L186.807 106.796C187.921 107.616 188.218 109.182 187.475 110.301C186.956 110.972 186.213 111.42 185.396 111.42L185.322 111.345Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.629 223C127.183 223 126.663 222.851 126.218 222.552C125.03 221.807 124.733 220.24 125.475 219.047L163.121 161.318C163.121 161.318 163.492 160.796 163.789 160.646L184.654 146.102C185.768 145.282 187.327 145.58 188.144 146.773C188.96 147.892 188.663 149.459 187.475 150.279L166.982 164.599L129.634 221.956C129.114 222.702 128.371 223.075 127.554 223.075L127.629 223Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.188 223C128.371 223 127.554 222.627 127.109 221.881L89.7605 164.525L69.2671 150.204C68.1533 149.384 67.8563 147.818 68.5988 146.699C69.4156 145.58 70.9748 145.282 72.0886 146.028L92.9533 160.572C92.9533 160.572 93.4731 161.019 93.6216 161.243L131.267 218.972C132.01 220.166 131.713 221.732 130.525 222.478C130.079 222.776 129.634 222.925 129.114 222.925L129.188 223Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.878 195.776C169.878 195.776 169.358 195.776 169.061 195.627C130.079 182.5 89.6862 195.478 89.3149 195.627C87.9784 196.075 86.5676 195.329 86.1221 193.986C85.6766 192.644 86.4191 191.227 87.7557 190.779C89.4635 190.182 130.079 177.055 170.695 190.779C172.031 191.227 172.699 192.644 172.254 193.986C171.883 195.03 170.917 195.702 169.878 195.702V195.776Z",
    fill: "#4B4B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.442 189.735C172.402 189.735 171.363 189.064 171.066 188.019L163.121 163.257C163.121 163.257 162.972 162.809 162.972 162.511L161.636 93.5939C161.636 93.5939 161.636 92.9226 161.784 92.6243L171.289 68.6077C171.808 67.3398 173.293 66.6685 174.556 67.1906C175.818 67.7127 176.486 69.2044 175.966 70.4724L166.685 94.041L168.022 162.064L175.892 186.453C176.338 187.796 175.595 189.213 174.259 189.66C174.036 189.735 173.739 189.809 173.516 189.809L173.442 189.735Z",
    fill: "#4B4B4B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOval);
export default __webpack_public_path__ + "static/media/Oval.b4b5c60d6c18f6e8b8cf8e3638f874ad.svg";
export { ForwardRef as ReactComponent };